import { forgetPasswordURL } from '../../libs/constants'
import { stringifyQueryString } from '../../libs/historyHelper'

export const REDIRECT_ACCOUNT_KEY = 'pw_reset_by'

export function createForgetPasswordURL(
  account: string,
  redirectURL: string,
): string {
  return `${forgetPasswordURL}?${stringifyQueryString({
    account,
    event_type: 'slash',
    redir_url: `${redirectURL}?${stringifyQueryString({
      [REDIRECT_ACCOUNT_KEY]: account,
    })}`,
  })}`
}
